export type Token = {
  name: string;
  address: string;
  network?: string;
};

export function tokensMapping(symbol: string): Token {
  const mapping: Record<string, Token> = {
    DAI: { name: 'DAI', address: '0x6b175474e89094c44da98b954eedeac495271d0f' },
    USDS: {
      name: 'USDS',
      address: '0x798f111c92e38f102931f34d1e0ea7e671bdbe31'
    },
    USDC: {
      name: 'USDC',
      address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
    },
    SPK: {
      name: 'SPK',
      address: '0xc20059e0317de91738d13af027dfc4a50781b066'
    }
  };

  return mapping[symbol];
}

export function tokensMappingArbitrum(symbol: string) {
  const mapping: Record<string, Token> = {
    USDC: {
      name: 'USDC',
      address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      network: 'arbitrum'
    },
    USDS: {
      name: 'USDS',
      address: '0x6491c05a82219b8d1479057361ff1654749b876b',
      network: 'arbitrum'
    },
    sUSDS: {
      name: 'sUSDS',
      address: '0xddb46999f8891663a8f2828d25298f70416d7610',
      network: 'arbitrum'
    },
    SKY: { name: 'SKY', address: '' }
  };
  return mapping[symbol];
}

export function tokensMappingBase(symbol: string) {
  const mapping: Record<string, Token> = {
    USDC: {
      name: 'USDC',
      address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      network: 'base'
    },
    USDS: {
      name: 'USDS',
      address: '0x820c137fa70c8691f0e44dc420a5e53c168921dc',
      network: 'base'
    },
    sUSDS: {
      name: 'sUSDS',
      address: '0x5875eee11cf8398102fdad704c9e96607675467a',
      network: 'base'
    },
    SKY: { name: 'SKY', address: '0x60e3c701e65dee30c23c9fb78c3866479cc0944a' }
  };

  return mapping[symbol];
}
